export function isAuthServiceUnavailableMessage(message: string | undefined): boolean {
  const normalized = message?.toLowerCase() ?? ""
  return (
    normalized.includes("unable to reach the authentication service") ||
    normalized.includes("supabase_network_error") ||
    normalized.includes("failed to fetch")
  )
}
